<template>
  <el-popover class="process" placement="bottom-start" trigger="hover" width="320">
    <div style="max-height: 200px; overflow-y:scroll;">
        <el-steps v-if="steps.length" direction="vertical" :style="{ height: (steps.length * 40) + 'px' }" :space="40">
          <el-step v-for="(step, index) in steps" :key="index" style="height:60px;">
            <template v-slot:icon style="height: 24px;">
              <el-progress
                :width="24"
                type="circle"
                :stroke-width="3"
                :percentage="step.rate"
                :show-text="false"
              ></el-progress>
            </template>
            <template v-slot:title class="title">
              <span class="txt-name">{{step.name}}</span>
              <span class="txt-date">{{step.time}}</span>
            </template>
          </el-step>
        </el-steps>
        <p v-else class="no-progress">暂无任务</p>
    </div>
    <el-button slot="reference" class="btn-progress" >
      <svg-icon @mouseenter="getTaskProgress()" icon-class="progress" class-name="progress-style"/>
    </el-button>
  </el-popover>
</template>

<script>
import { getTaskProgress } from "@/api/login.js"
export default {
  name: "Progress",
  data() {
    return {
      steps: []
    };
  },
  methods: {
    async getTaskProgress(){
      try{
        const data = await getTaskProgress()
        this.steps = data
      } catch(e){
        console.log(e)
      }
      // if(Math.random() > 0){
      //   this.steps.push({name: '生成抽检', rate: 100, time: '12-12 10:22:33'})
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-progress {
  color: white;
  border: none;
  background: inherit;
  font-size: 20px;
  margin-top: 12px;
  //margin-top: 22px;
}
.txt-name {
      display: inline-block;
      width: 6em;
      color: gray;
    }
    .txt-date {
      display: inline-block;
      padding-right: 20px;
    }
/deep/ .el-step__line {
      color: #eeeeee;
      background-color: #eeeeee;
    }
/deep/ .el-progress-circle__track {
      stroke: #b0d9ff;
    }
/deep/ .el-progress-circle__path {
  stroke: #1990ff;
}
.no-progress {
  font-size: 16px;
  color: #999999;
  margin: 10px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Progress.vue